// src/redux/actions/cityActions.js
import {
    FETCH_GETORGDINS_REQUEST,
    FETCH_GETORGDINS_SUCCESS,
    FETCH_GETORGDINS_FAILURE,
    SET_SELECTED_GETORGDINS,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchOrgRegdInsData = (searchTerm = '') => async (dispatch) => {
    dispatch({ type: FETCH_GETORGDINS_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetAllOrgsDDL?Search=${searchTerm}&Type=Institution`);
      console.log("getallorgs :", response);
      let getallorgsList = response.data.responseData.map((val) => {
        return {
          value: val.id,
          label: val.name,
          tagId: val.tagID
        }
      })
      dispatch({
        type: FETCH_GETORGDINS_SUCCESS,
        payload: getallorgsList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GETORGDINS_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectRegdIns = (getallorgsId) => ({
    type: SET_SELECTED_GETORGDINS,
    payload: getallorgsId,
  });
  